module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "img11_2",
      "src": "images/img11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Major Theodore Roosevelt leading a company of officer candidates to mess at first Plattsburg training camp. Major Roosevelt fought in France with the First Division, was wounded, decorated, and came home a lieutenant colonel. He entered politics and became Governor-General of the Philippines in 1932. With the onset of the Second World War he returned to active duty and was given command of the 26th Infantry Regiment, 1st Infantry Division. Roosevelt saw action in North Africa, Sicily and commanded Allied Forces in Sardinia and on the Italian mainland. He was the chief liaison officer to the French Army in Italy for General Dwight D. Eisenhower. Despite a heart condition and arthritis that forced him to use a cane, General Roosevelt led the assault on Utah Beach, landing with the first wave of troops. He died in France less than a month later of a heart attack. 7US")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d8f9c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01l_AMERICAN_EXPEDITIONARY_FORCE.vue
// module id = 105
// module chunks = 0